var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 47.5L25.5 0L50.5 47.5H0.5ZM28 37.5V42.5H23V37.5H28ZM23 17.5V32.5H28V17.5H23Z",
    fill: "#F16E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attention_icon.f0b61c39a773cf45522de693cc71ca07.svg";
export { ForwardRef as ReactComponent };